import { type JSX } from 'solid-js'

import Css from './ui.module.scss'

/** O girador de espera. */
export function Spinner(props: { class?: string }): JSX.Element {
    return (
        <svg viewBox="0 0 24 24" fill="none" class={`${Css.spinner} ${props.class ?? ''}`} aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2.5" opacity="0.2" />
            <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
        </svg>
    )
}

/** A tela inteira esperando a primeira resposta. */
export function Loading(): JSX.Element {
    return (
        <div class={Css.loadingScreen}>
            <Spinner class={Css.loadingSpinner} />
        </div>
    )
}
